<template>
	<OneOnOneLayout
		:team-id="teamId"
	>
		<template #view="{ team, teamLoaded }">
			<main class="one-on-one-layout__tab-container">
				<router-view v-if="teamLoaded"
					:teamId="teamId"
					:team="team"
					:key="`${ teamId }.${ docType }`"
					v-bind="$attrs"
				/>
			</main>
		</template>
	</OneOnOneLayout>
</template>

<script>
import OneOnOneLayout from "./OneOnOneLayout.vue";

export default {
	name: "OneOnOneStreamLayout",
	components: {
		OneOnOneLayout,
	},
	props: {
		teamId: {
			type: String,
			required: true,
		},
		docType: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss">
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	height: 100%;
}
</style>

<style lang="scss" scoped>
.one-on-one-layout__tab-container {
	@include auto-y-scroll();
	width: 100%;
	flex: 1;
	position: relative;
	display: flex;
	flex-direction: column;
}
</style>
